export const shouldLoadEventsOnMenuOpen = ({
  eventsLoadedRef,
  tournamentSelection,
}) => {
  return (
    (!eventsLoadedRef.current.loaded ||
      eventsLoadedRef.current.id !== tournamentSelection?.id) &&
    Boolean(tournamentSelection?.id)
  )
}

export const handleEventsMenuOpen = ({
  eventsLoadedRef,
  tournamentSelection,
  loadEvents,
  isMountedRef,
  setAvailableEvents,
  setFilteredEvents,
  setRenderKey,
  log,
}) => {
  if (
    !shouldLoadEventsOnMenuOpen({
      eventsLoadedRef,
      tournamentSelection,
    })
  ) {
    return Promise.resolve()
  }

  return loadEvents('', tournamentSelection.id)
    .then((events) => {
      if (!isMountedRef.current) return

      const validEvents = events || []

      setAvailableEvents(validEvents)
      setFilteredEvents(validEvents)
      eventsLoadedRef.current = {
        id: tournamentSelection.id,
        loaded: true,
      }
      setRenderKey((prev) => prev + 1)
    })
    .catch((error) => {
      log('Error loading events on menu open:', error)
    })
}

export const handleAthletesMenuOpen = ({
  eventSelection,
  athletesCacheRef,
  loadAthletes,
  isMountedRef,
  setAvailableAthletes,
  setFilteredAthletes,
  athletesLoadedRef,
  log,
}) => {
  if (!eventSelection) {
    return Promise.resolve()
  }

  const eventId = eventSelection.id
  const cachedAthletes = athletesCacheRef.current.get(eventId)

  if (cachedAthletes) {
    log(`Using ${cachedAthletes.length} cached athletes for event ${eventId}`)
    setAvailableAthletes(cachedAthletes)
    setFilteredAthletes(cachedAthletes)
    return Promise.resolve(cachedAthletes)
  }

  return loadAthletes('', eventId)
    .then((athletes) => {
      if (!isMountedRef.current) return

      const validAthletes = athletes || []
      log(`Loaded ${validAthletes.length} athletes for event ${eventId}`)

      setAvailableAthletes(validAthletes)
      setFilteredAthletes(validAthletes)
      athletesLoadedRef.current = { id: eventId, loaded: true }
      athletesCacheRef.current.set(eventId, validAthletes)
    })
    .catch((error) => {
      log('Error loading athletes:', error)
    })
}
